const { isNumber } = require('./is-number')
const { size } = require('./size')

// ? ******************************************************************************************
// ? ******************************************************************************************

/**
 * @param {*} value
 * @returns {boolean}
 */
function usableValue (value) {
  return (!!size(value) || isNumber(value) || value === true || value === false || value instanceof RegExp)
}

module.exports = { usableValue }
